// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Auth_Wrapper__3jbGy"};